"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getSelectorFromElement(element, attribute, fallbackHref) {
    if (attribute === void 0) { attribute = 'data-target'; }
    if (fallbackHref === void 0) { fallbackHref = true; }
    var selector = element.getAttribute(attribute);
    if (!selector && fallbackHref) {
        selector = element.getAttribute('href') || '';
        selector = /^#.*/i.test(selector) ? selector : null;
    }
    return selector;
}
exports.default = getSelectorFromElement;
